export default {
  id: 'cross-chain',
  instructionInfo: [
    '一个常见的使用场景是资产的跨链转移，当用户之间需要做资产转移，但各自使用的区块链不是同一种链的时候，就可以使用跨链服务，例如将数字资产从一个区块链网络转移到另一个区块链网络，实现跨链的价值流动和交易。'
  ]
}
